// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"0872053d","143":"afcf8962","144":"39861890","494":"95267266","533":"d1e3c96e","651":"844234d8","690":"a8d1c565","852":"d9b8e89b","940":"8e2cf805"}[chunkId] + ".chunk.js";
};